'use client';

import { HelpCenterChatWidget } from 'components/pcc-components';
import { useHelpCenterLinkClient } from 'hooks/use-help-center-link/use-help-center-link.client';

export const OnBoardedChatClient = ({
  helpCenterUrl,
  title,
  buttonText,
  delayMinutesToDisplay,
}: {
  helpCenterUrl: string;
  title: string;
  buttonText: string;
  delayMinutesToDisplay: string;
}) => {
  const { helpCenterUrlWithCurrentPage } = useHelpCenterLinkClient({
    helpCenterUrl,
  });
  const linkToHelpChat = `${helpCenterUrlWithCurrentPage}&chatopen=true`;

  return (
    <HelpCenterChatWidget
      title={title}
      buttonText={buttonText}
      linkToHelpChat={linkToHelpChat}
      delayMinutesToDisplay={delayMinutesToDisplay}
    />
  );
};
